import { useEffect, useState } from "react";
import classNames from "classnames";
import { ComponentLoader } from "./Loader";
import styles from "./styles.module.scss";
import { NodeTypeIcon } from "./Column";
import { useReactFlow } from "reactflow";
import { useLineageContext } from "../context/LineageProvider";
import { ExposureMetaData } from "../types";
import { getExposureDetails } from "../api";
import PurposeSection from "./Purpose";
import ColumnRow from "./ColumnRow";
import Chip from "./Chip";
import { Stack } from "@altimateai/lego";

/**
 * Component to display exposure details
 */
const ExposureDetails = () => {
  const flow = useReactFlow();
  const {
    state: { selectedTable },
  } = useLineageContext();
  const [data, setData] = useState<ExposureMetaData | null>(null);
  const selectedTableData = flow.getNode(selectedTable)?.data;
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!selectedTable) return;
    getExposureDetails(selectedTable).then(_data => {
      setData(_data);
      setIsLoading(false);
    });
  }, [selectedTable]);

  if (isLoading || !data || !selectedTable) return <ComponentLoader />;

  return (
    <Stack direction="column" gap="md" className="p-2 al-h-full al-overflow-y">
      <div className={styles.table_details_header}>
        <NodeTypeIcon nodeType={selectedTableData.nodeType} />
        <Stack direction="row" align="center">
          <div className="fw-semibold fs-5 lines-2">{selectedTableData.label}</div>
        </Stack>
      </div>
      {data.description ? <PurposeSection purpose={data.description} /> : null}
      <div className={classNames(styles.card, "flex-grow column-section")}>
        <ColumnRow title="Owner" value={`${data.owner.name} - ${data.owner.email}`} />
        <ColumnRow title="Url" value={data.url} />
        <ColumnRow
          title="Tags"
          value={data.tags.map(tag => (
            <Chip label={tag} key={tag} />
          ))}
        />
        <ColumnRow title="Maturity" value={data.maturity} />
      </div>
    </Stack>
  );
};

export default ExposureDetails;
